/**
 * Features Schema
 * Schema-driven settings for features/benefits section
 */
export default {
  id: 'features',
  version: 1,
  title: 'Преимущества',
  description: 'Блок с карточками преимуществ или особенностей',
  icon: 'Star',
  category: 'content',

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Наши преимущества',
          defaults: { size: '3xl', weight: 'bold', color: 'foreground' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Почему выбирают нас',
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'style',
          type: 'select',
          label: 'Стиль',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'cards', label: 'Карточки' },
            { value: 'minimal', label: 'Минимальный' },
            { value: 'icons-left', label: 'Иконки слева' }
          ]
        },
        {
          key: 'columns',
          type: 'select',
          label: 'Колонок',
          options: [
            { value: 2, label: '2' },
            { value: 3, label: '3' },
            { value: 4, label: '4' }
          ]
        }
      ]
    },
    {
      group: 'Преимущества',
      fields: [
        {
          key: 'items',
          type: 'list',
          label: 'Преимущества',
          addLabel: 'Добавить',
          itemLabel: 'Пункт',
          itemFields: [
            {
              key: 'icon',
              type: 'icon',
              label: 'Иконка',
              default: 'Star'
            },
            {
              key: 'title',
              type: 'text',
              label: 'Заголовок',
              placeholder: 'Название преимущества',
              defaults: { size: 'lg', weight: 'semibold', color: 'foreground' }
            },
            {
              key: 'description',
              type: 'text',
              label: 'Описание',
              placeholder: 'Описание преимущества',
              multiline: true,
              rows: 2,
              defaults: { size: 'sm', weight: 'normal', color: 'secondary' }
            }
          ]
        }
      ]
    }
  ],

  default: {
    title: { text: 'Наши преимущества' },
    subtitle: { text: 'Почему выбирают нас' },
    style: 'cards',
    columns: 3,
    items: [
      { id: '1', icon: 'MapPin', title: { text: 'Удобное расположение' }, description: { text: 'В центре города с отличной транспортной доступностью' } },
      { id: '2', icon: 'Wifi', title: { text: 'Высокоскоростной интернет' }, description: { text: 'Стабильное подключение до 1 Гбит/с' } },
      { id: '3', icon: 'Clock', title: { text: 'Гибкий график' }, description: { text: 'Доступ 24/7 для всех резидентов' } }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      if (migrated.items) {
        migrated.items = migrated.items.map(item => ({
          ...item,
          id: item.id || Date.now().toString(),
          title: typeof item.title === 'string' ? { text: item.title } : (item.title || { text: '' }),
          description: typeof item.description === 'string' ? { text: item.description } : (item.description || { text: '' })
        }));
      }
      return migrated;
    }
    return data;
  }
};
